exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cookie-manager span {\n  vertical-align: super; }\n\n.cookie-manager .react-switch {\n  margin-left: 10px;\n  margin-top: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/style/components/notification/cookie-manager.scss
// module id = 1224
// module chunks = 49